var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigationNewCalendar = function SvgNavigationNewCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 1v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h9v-2H5V9h14v5h2V5c0-1.1-.9-2-2-2h-1V1h-2v2H8V1H6Zm0 4H5v2h14V5H6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3Z"
  })));
};
export default SvgNavigationNewCalendar;